import React from "react"
import PropTypes from "prop-types"
import { Nav } from "react-bootstrap"

import { preventDefault } from "../../../utils"
import { getFormattedMessage } from "../../../../components/shared_components_registration"

export const TabTitle = ({
  intl,
  eventKey,
  title,
  disabled = false,
  isPlaceholder = false,
  missing_parental_information = false,
}) => {
  return (
    <Nav.Item>
      <Nav.Link
        href={title}
        eventKey={eventKey}
        onClick={preventDefault}
        disabled={disabled}
        className={missing_parental_information ? "inoculate_warning" : ""}
      >
        <div>
          {isPlaceholder && (
            <>
              <span className="fa fa-bookmark-o text-success" />
              &nbsp;
            </>
          )}
          {title}
          {missing_parental_information && ( // LTPM concept
            <>
              &nbsp;
              <span
                className="fa fa-play text-danger"
                title={getFormattedMessage(
                  "fermmanagement.missing.inoculation.warn.msg",
                  "This run has not been inoculated yet",
                  true,
                  intl,
                )}
              />
            </>
          )}
        </div>
      </Nav.Link>
    </Nav.Item>
  )
}

TabTitle.propTypes = {
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}
